"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualificationsRequiredForJob = void 0;
const typeorm_1 = require("typeorm/browser");
const job_status_enum_1 = require("./job-status-enum");
const service_view_1 = require("./service-view");
let QualificationsRequiredForJob = class QualificationsRequiredForJob {
};
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], QualificationsRequiredForJob.prototype, "jobSfid", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], QualificationsRequiredForJob.prototype, "isRemote", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "hwoA", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "hwoB1", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "hwoB2", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'kein_hwo',
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "noHwo", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'weiterbildung',
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "additionalEducation", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'zusatzqualifikation',
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "additionalQualification", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'text',
        array: true,
        name: 'transporter',
    }),
    __metadata("design:type", Array)
], QualificationsRequiredForJob.prototype, "transporter", void 0);
QualificationsRequiredForJob = __decorate([
    (0, typeorm_1.ViewEntity)({
        dependsOn: [service_view_1.ServiceView],
        expression: `
    SELECT
      j.sfid job_sfid,
      BOOL_AND(s.is_remote__c) is_remote,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.hwo_a__c,';'),';'),'keine')) a(u)) hwo_a,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.hwo_b1__c,';'),';'),'keine')) a(u)) hwo_b1,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.hwo_b2__c,';'),';'),'keine')) a(u)) hwo_b2,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.kein_hwo__c,';'),';'),'keine')) a(u)) kein_hwo,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.weiterbildung__c,';'),';'),'keine')) a(u)) weiterbildung,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.zusatzqualifikation__c,';'),';'),'keine')) a(u)) zusatzqualifikation,
      ARRAY(SELECT DISTINCT u FROM UNNEST(array_remove(string_to_array(STRING_AGG(s.transporter__c,';'),';'),'Kein')) a(u)) transporter
    FROM
      public.job__c j
    LEFT JOIN
      public.job_service__c js
      ON (js.job_id = j.api_id__c AND js.is_active__c)
    LEFT JOIN
      public.service s
      ON (s.sfid = js.service__c AND s.opportunity__c = j.opportunity__c)
    WHERE
      j.status__c IN (
        '${job_status_enum_1.JobStatusEnum.NEW}',
        '${job_status_enum_1.JobStatusEnum.OPEN}',
        '${job_status_enum_1.JobStatusEnum.APPOINTMENT_CONFIRMED}',
        '${job_status_enum_1.JobStatusEnum.ACCEPTED}',
        '${job_status_enum_1.JobStatusEnum.ON_HOLD}',
        '${job_status_enum_1.JobStatusEnum.PROPOSAL_APPROVAL_PENDING}',
        '${job_status_enum_1.JobStatusEnum.BRAND_PROPOSAL_APPROVAL_PENDING}'
      )
    GROUP BY
      j.sfid
  `,
        name: 'qualifications_required_for_job',
        schema: 'public',
    })
], QualificationsRequiredForJob);
exports.QualificationsRequiredForJob = QualificationsRequiredForJob;
//# sourceMappingURL=qualifications-required-for-job.js.map